module.exports = __webpack_public_path__ + "img/ico17.e3466fb1.svg";